module.exports = __webpack_public_path__ + "480c7600bdfe6216f93caf12f087a449.svg";